import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type ContainerProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'search';
} & React.ComponentPropsWithoutRef<'div'>;
const sizeStyles = {
  xs: 'max-w-[460px]',
  sm: 'max-w-[600px]',
  md: 'max-w-[900px]',
  lg: 'max-w-[1200px]',
  xl: 'max-w-[1536px]',
  search: 'max-w-[780px]'
};
export function Container(t0) {
  const $ = _c(6);
  const {
    className,
    size,
    children
  } = t0;
  const t1 = sizeStyles[size || "xl"];
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = twMerge("relative mx-auto w-full px-4 md:px-6", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}